'use strict';

module.exports = duration;

function duration(unit, rounded) {
    return this.diff(unit, rounded);
}



// WEBPACK FOOTER //
// ./src/moment-wrange/lib/duration.js